import React, { useEffect, useState } from "react";
import { Dropdown, DropdownProps } from "@/components/bp/bp-ui";

interface AsyncDropdownProps {
  defaultValue?: any;
  dataSource: () => Promise<Array<{ key: any; value: any; text: string }>>;
  onChange?: (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => void;
  optionsChanged?: (data: Array<{ key: any; value: any; text: string }>) => void;
  placeholder?: string;
  disabled?: boolean;
  fluid?: boolean;
  selection?: boolean;
  search?: boolean;
  clearable?: boolean;
}

export const AsyncDropdown: React.FC<AsyncDropdownProps> = ({
  defaultValue,
  dataSource,
  onChange,
  placeholder,
  disabled,
  fluid = true,
  selection = true,
  search = false,
  clearable = false,
  optionsChanged
}) => {
  const [options, setOptions] = useState<Array<{ key: any; value: any; text: string }>>([]);
  const [selected, setSelected] = useState<any>(defaultValue);

  useEffect(() => {
    let mounted = true;
    dataSource().then((data) => {
      if (mounted) setOptions(data);
    });
    return () => { mounted = false; };
  }, [dataSource]);

  useEffect(() => {
    if (optionsChanged) optionsChanged(options);
  }, [options]);

  useEffect(() => {
    handleChange(null, { value: defaultValue });
    // setSelected(defaultValue);
  }, [defaultValue]);

  const handleChange = (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
    setSelected(data.value);
    if (onChange) onChange(event, data);
  };

  return (
    <Dropdown
      options={options}
      value={selected}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      fluid={fluid}
      selection={selection}
      search={search}
      clearable={clearable}
    />
  );
};